export const ProfileIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_527_564)">
      <path d="M7.99984 8.00002C9.47317 8.00002 10.6665 6.80669 10.6665 5.33335C10.6665 3.86002 9.47317 2.66669 7.99984 2.66669C6.5265 2.66669 5.33317 3.86002 5.33317 5.33335C5.33317 6.80669 6.5265 8.00002 7.99984 8.00002ZM7.99984 9.33335C6.21984 9.33335 2.6665 10.2267 2.6665 12V13.3334H13.3332V12C13.3332 10.2267 9.77984 9.33335 7.99984 9.33335Z" />
    </g>
    <defs>
      <clipPath id="clip0_527_564">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
